import { ArrowRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";

export function Navbar() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <nav className="nav-shell" aria-label="Main navigation">
        <Logo />
        <button className="mobile-nav-toggle" onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label="Toggle navigation">
          {open ? <X /> : <Menu />}
        </button>
        <div className={`nav-links ${open ? "is-open" : ""}`}>
          <a href="/#curriculum" onClick={() => setOpen(false)}>Curriculum</a>
          <a href="/#plans" onClick={() => setOpen(false)}>Plans</a>
          <a href="/#faq" onClick={() => setOpen(false)}>FAQ</a>
          {user ? (
            <Link className="button button-small button-primary" to="/dashboard" onClick={() => setOpen(false)}>
              Dashboard <ArrowRight size={16} />
            </Link>
          ) : (
            <>
              <NavLink className="nav-login" to="/login" onClick={() => setOpen(false)}>Log in</NavLink>
              <Link className="button button-small button-primary" to="/signup" onClick={() => setOpen(false)}>
                Start learning <ArrowRight size={16} />
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
